export const getVideaNoteByIdQueryKey = (
  organizationId: string,
  practiceId: string,
  clinicalNoteId: string | undefined,
) =>
  ['videa-note-by-id', organizationId, practiceId, clinicalNoteId] as const;
